import { DeviceTypes } from "../../config/documents/HardwareConfig";
import PoolDeviceActuatorTwoWay from "./ActuatorTwoWay";
import { PoolDeviceInterface } from "../Interfaces";
import Locale from "../../utils/Locale";

export { criticalFieldIdentifiers } from "./ActuatorTwoWay"; 

export default class PoolDeviceActuatorThreeWay extends PoolDeviceActuatorTwoWay implements PoolDeviceInterface {
    static PickerTitle = Locale.gettext("Actuator 3-Way");
    static Icon = "actuator3";
    static DeviceType = DeviceTypes.ACTUATORTHREEWAY;
}